import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "message-form"
}
const _hoisted_2 = { class: "message-form" }
const _hoisted_3 = {
  key: 1,
  class: "message-form-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormBranch = _resolveComponent("FormBranch")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return ($setup.content.type === 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FormBranch, {
            title: $setup.content.header,
            list: $setup.content.items,
            selectedContent: $setup.content.selected && $setup.content.selected.content,
            onInputClick: $setup.handleContentListItemClick
          }, null, 8, ["title", "list", "selectedContent", "onInputClick"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_FormInput, {
          title: $setup.content.header,
          selectedContent: $setup.content.selected && $setup.content.selected.content,
          onInputSubmit: $setup.handleFormSaveInputSubmit
        }, null, 8, ["title", "selectedContent", "onInputSubmit"])
      ]))
}